// iter157 — Paylaşılan /shop/tree hook'u: HTML preload + module memory + localStorage cache
import { useEffect, useState } from "react";
import { api } from "../lib/api";

const KEY = "bordo:shop:tree:v3";
const TTL = 30 * 60 * 1000; // 30 dk (backend server TTL ile uyumlu)

let _sharedPromise = null;
let _mem = null;

async function fetchTree() {
  // 1. HTML head'de erken fetch edildiyse onu kullan
  try {
    if (typeof window !== "undefined") {
      if (window.__SHOP_TREE__) return window.__SHOP_TREE__;
      if (window.__SHOP_TREE_PROMISE__) {
        const d = await window.__SHOP_TREE_PROMISE__;
        if (d) return d;
      }
    }
  } catch { /* ignore */ }

  // 2. localStorage cache'den oku (30 dk TTL), arkada yenile
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const c = JSON.parse(raw);
      if (c && c.at && (Date.now() - c.at) < TTL && c.data) {
        _mem = c.data;
        api.get("/shop/tree").then(r => {
          _mem = r.data;
          try { localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), data: r.data })); } catch {}
        }).catch(() => {});
        return c.data;
      }
    }
  } catch { /* ignore */ }

  // 3. Network fetch
  const { data } = await api.get("/shop/tree");
  _mem = data;
  try { localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), data })); } catch {}
  return data;
}

export function preloadShopTree() {
  if (!_sharedPromise) _sharedPromise = fetchTree();
  return _sharedPromise;
}

export default function useShopTree() {
  // window.__SHOP_TREE__ ilk render'da varsa hemen kullan (skeleton flash olmaz)
  const initial = (typeof window !== "undefined" && window.__SHOP_TREE__) || _mem || { categories: [], brands: [] };
  const [tree, setTree] = useState(initial);
  const [loading, setLoading] = useState(!initial.categories?.length);
  useEffect(() => {
    if (initial.categories?.length) return;
    let cancelled = false;
    preloadShopTree().then((d) => { if (!cancelled) { setTree(d || { categories: [], brands: [] }); setLoading(false); } })
      .catch(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);
  return { tree, loading };
}
